<template>
  <div class="medical-page">
    <medical-top-bar :show-search="false" />
    <section class="drug-hero" v-if="drugData">
      <div class="page-header">
        <button class="back-btn" @click="goBack">
          <span class="back-btn__icon">←</span>
          <span>返回</span>
        </button>
      </div>
      <div class="drug-hero__main">
        <div class="drug-head">
          <div class="drug-packshot">
            <div class="drug-packshot__label" v-if="drugData.OTCType">
              {{ drugData.OTCType }}
            </div>
            <div class="drug-packshot__box">
              <span>说明书示意</span>
            </div>
          </div>
          <div class="drug-head__content">
            <h1>{{ drugData.MedicineName }}</h1>
            <p>{{ drugData.Indications || "" }}</p>
            <div class="status-tags" v-if="drugData.Tags">
              <span v-for="item in parseTags(drugData.Tags)" :key="item">{{
                item
              }}</span>
            </div>
          </div>
        </div>
        <div class="field-grid">
          <article class="field-card" v-if="drugData.GenericName">
            <div class="field-card__label">通用名称</div>
            <div class="field-card__value">{{ drugData.GenericName }}</div>
          </article>
          <article class="field-card" v-if="drugData.BrandName">
            <div class="field-card__label">商品名称</div>
            <div class="field-card__value">{{ drugData.BrandName }}</div>
          </article>
          <article class="field-card" v-if="drugData.Manufacturer">
            <div class="field-card__label">生产企业</div>
            <div class="field-card__value">{{ drugData.Manufacturer }}</div>
          </article>
          <article class="field-card" v-if="drugData.ApprovalNumber">
            <div class="field-card__label">批准文号</div>
            <div class="field-card__value">{{ drugData.ApprovalNumber }}</div>
          </article>
        </div>
      </div>
    </section>

    <section class="anchor-bar" v-if="hasDetailSections">
      <a href="#components" v-if="drugData.Components">成份</a>
      <a href="#indications" v-if="drugData.Indications">适应症</a>
      <a href="#usage" v-if="drugData.UsageDosage">用法用量</a>
      <a href="#adverse" v-if="drugData.AdverseReactions">不良反应</a>
      <a href="#contraindications" v-if="drugData.Contraindications">禁忌</a>
      <a href="#precautions" v-if="drugData.Precautions">注意事项</a>
    </section>

    <main class="page-layout">
      <section class="page-main">
        <article
          id="components"
          class="content-card"
          v-if="drugData.Components"
        >
          <h2>成份</h2>
          <p class="section-content">{{ drugData.Components }}</p>
        </article>

        <article
          id="indications"
          class="content-card"
          v-if="drugData.Indications"
        >
          <h2>适应症</h2>
          <p class="section-content">{{ drugData.Indications }}</p>
        </article>

        <article id="usage" class="content-card" v-if="drugData.UsageDosage">
          <h2>用法用量</h2>
          <p class="section-content">{{ drugData.UsageDosage }}</p>
        </article>

        <article
          id="adverse"
          class="content-card"
          v-if="drugData.AdverseReactions"
        >
          <h2>不良反应</h2>
          <p class="section-content">{{ drugData.AdverseReactions }}</p>
        </article>

        <article
          id="contraindications"
          class="content-card"
          v-if="drugData.Contraindications"
        >
          <h2>禁忌</h2>
          <p class="section-content">{{ drugData.Contraindications }}</p>
        </article>

        <article
          id="precautions"
          class="content-card"
          v-if="drugData.Precautions"
        >
          <h2>注意事项</h2>
          <p class="section-content">{{ drugData.Precautions }}</p>
        </article>

        <article
          id="properties"
          class="content-card"
          v-if="drugData.Properties"
        >
          <h2>性状</h2>
          <p class="section-content">{{ drugData.Properties }}</p>
        </article>

        <article id="storage" class="content-card" v-if="drugData.Storage">
          <h2>贮藏</h2>
          <p class="section-content">{{ drugData.Storage }}</p>
        </article>

        <article id="package" class="content-card" v-if="drugData.Package">
          <h2>包装</h2>
          <p class="section-content">{{ drugData.Package }}</p>
        </article>

        <article
          id="validity"
          class="content-card"
          v-if="drugData.ValidityPeriod"
        >
          <h2>有效期</h2>
          <p class="section-content">{{ drugData.ValidityPeriod }}</p>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
import MedicalTopBar from "./components/MedicalTopBar.vue";
import axios from "axios";

export default {
  name: "MedicalDrugDetail",
  components: {
    MedicalTopBar,
  },
  data() {
    return {
      drugData: {},
      loading: false,
    };
  },
  computed: {
    hasDetailSections() {
      return (
        this.drugData.Components ||
        this.drugData.Indications ||
        this.drugData.UsageDosage ||
        this.drugData.AdverseReactions ||
        this.drugData.Contraindications ||
        this.drugData.Precautions
      );
    },
  },
  mounted() {
    this.fetchDrugDetail();
  },
  methods: {
    async fetchDrugDetail() {
      const drugId = this.$route.query.id || 167;
      this.loading = true;
      try {
        const response = await axios.get(
          `http://192.168.10.13:8087/ug/disease-department/medicine-detail?id=${drugId}`,
        );
        if (
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          this.drugData = response.data.data[0];
        }
      } catch (error) {
        console.error("获取药品详情失败:", error);
      } finally {
        this.loading = false;
      }
    },
    parseTags(tagsStr) {
      if (!tagsStr) return [];
      try {
        return JSON.parse(tagsStr);
      } catch (e) {
        return tagsStr.split(",").map((t) => t.trim());
      }
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.medical-page {
  min-height: 100vh;
  background: radial-gradient(
      circle at top center,
      rgba(37, 99, 235, 0.08),
      transparent 26%
    ),
    linear-gradient(180deg, #f6fbff 0%, #eef7ff 45%, #f8fafc 100%);
  color: #0f172a;
}

.drug-hero,
.anchor-bar,
.page-layout {
  max-width: 1200px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;
}

.drug-hero__main,
.content-card {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.drug-hero__main {
  padding: 28px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  margin-top: 16px;
  padding: 0 10px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 0;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;
}

.back-btn:hover {
  color: #0f766e;
}

.back-btn__icon {
  font-size: 16px;
}

.drug-head {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.drug-packshot {
  position: relative;
}

.drug-packshot__label {
  position: absolute;
  left: 12px;
  top: 12px;
  z-index: 1;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: #c2410c;
  font-size: 12px;
  font-weight: 700;
}

.drug-packshot__box {
  height: 240px;
  border-radius: 24px;
  background: radial-gradient(
      circle at 30% 20%,
      rgba(255, 255, 255, 0.55),
      transparent 28%
    ),
    linear-gradient(135deg, #fb923c, #f97316);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.24);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 20px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 14px;
  font-weight: 700;
}

.drug-head__content h1 {
  margin: 0;
  font-size: 36px;
}

.drug-head__content p {
  margin: 14px 0 0;
  color: #475569;
  line-height: 1.9;
}

.status-tags {
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.status-tags span {
  padding: 9px 14px;
  border-radius: 999px;
  background: rgba(249, 115, 22, 0.1);
  color: #c2410c;
  font-size: 13px;
  font-weight: 700;
}

.field-grid {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.field-card {
  padding: 18px;
  border-radius: 18px;
  background: #fffaf5;
  border: 1px solid rgba(249, 115, 22, 0.1);
}

.field-card__label {
  color: #64748b;
  font-size: 12px;
}

.field-card__value {
  margin-top: 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.7;
}

.anchor-bar {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.anchor-bar a {
  text-decoration: none;
  color: #0f172a;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  font-size: 14px;
  font-weight: 600;
}

.page-layout {
  padding-bottom: 36px;
  display: block;
}

.page-main {
  display: grid;
  gap: 20px;
}

.content-card {
  padding: 24px;
}

.content-card h2 {
  margin: 0 0 14px;
  font-size: 22px;
}

.bullet-list {
  margin: 0;
  padding-left: 18px;
  line-height: 1.9;
  color: #334155;
}

.bullet-list li + li {
  margin-top: 10px;
}

.section-content {
  margin: 0;
  line-height: 1.9;
  color: #334155;
  font-size: 15px;
}

.article-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.article-card {
  padding: 20px;
  border-radius: 20px;
  background: linear-gradient(180deg, #fff8f1, #fff1e6);
  border: 1px solid rgba(249, 115, 22, 0.12);
}

.article-card h3 {
  margin: 0;
  font-size: 18px;
}

.article-card p {
  margin: 12px 0 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.8;
}

@media (max-width: 1080px) {
  .drug-hero,
  .page-layout {
    grid-template-columns: 1fr;
  }

  .article-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .drug-hero,
  .anchor-bar,
  .page-layout {
    padding-left: 16px;
    padding-right: 16px;
  }

  .drug-head {
    grid-template-columns: 1fr;
  }

  .drug-head__content h1 {
    font-size: 30px;
  }

  .drug-hero__main,
  .content-card {
    padding: 20px;
  }

  .field-grid {
    grid-template-columns: 1fr;
  }
}
</style>
